<div class="payment-method-wrapper d-flex flex-column">
  <div
    class="payment-method p-3 d-flex align-items-center gap-3"
    (click)="onSelectMethod(paymentMethodInfo.paymentMode)" (keydown)="handleDropdownKey($event)"
  >
    <img [src]="'assets/images/' + paymentMethodInfo.icon" [alt]="paymentMethodInfo.label"/>
    <span>{{ paymentMethodInfo.label }}</span>
  </div>

  <div *ngIf="isSelected" class="expanded-payment-section">
    <div class="expanded-payment-wrapper gap-4 d-flex flex-column">
      <div class="d-flex pay-now-container gap-4">
        <div class="d-flex flex-column gap-2 pay-now-section">
          <div class="form-group d-flex align-items-center gap-2">
            <label for="payNowAmount" class="visually-hidden">Amount</label>
            <input
              id="payNowAmount"
              class="form-control form-control-sm vkeyboard flex-grow-1"
              type="text"
              spellcheck="false"
              data-ms-editor="true"
              [disabled]="!enableAmountCheckbox"
              [value]="isFocused ? payNowAmount : inputAmountFormatted(payNowAmount)"
              (focus)="isFocused = true"
              (blur)="onAmountBlur($event)"
              (input)="onAmountChange($event)"
              placeholder="Enter Amount"
              [class.is-invalid]="isInputEnabled && !isAmountValid()"
              [ngClass]="{'is-invalid': payableExceeded || limitExceeded || amountZero}"
            />
            <button
              type="button"
              class="btn btn-primary generate-qr-btn"
              data-bs-toggle="modal"
              data-bs-target="#qrCodeModal"
              [disabled]="this.payableExceeded || this.limitExceeded || this.amountZero"
              (click)="onGenerateQrClicked()"
            >
              <i class="fa-solid fa-qrcode me-2"></i>Generate QR
            </button>
          </div>
          <div *ngIf="payableExceeded || amountZero" class="text-danger mt-1">
            <small>
              <span class="error-icon">–</span>
              {{ amountZero ? 'Amount must be greater than 0.' : 'Amount must be less than or equal to ' + showAmountFormatted(this.pacDetails.balancePayable) + '.' }}
            </small>
          </div>
          <div *ngIf="limitExceeded" class="text-danger mt-1">
            <small>
              <span class="error-icon">–</span>
              Entered amount exceeded the maximum payable amount {{showAmountFormatted(this.paymentMethodInfo?.totalLimit ?? 0)}}.
            </small>
          </div>
          <div class="form-check">
            <label class="form-check-label" for="CheckboxDefault121">
              <input
                class="form-check-input"
                type="checkbox"
                name="CheckboxDefault11"
                id="CheckboxDefault121"
                [(ngModel)]="enableAmountCheckbox"
                (change)="toggleAmountInput($event)"
              />
              Change Amount<span class="checkbox-overlay"></span>
            </label>
          </div>
          <div *ngIf="enableAmountCheckbox" class="p-3 mb-4 mt-3"
               style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
            <div class="mt-0 mb-0 ">
              Full payment is required. Indicate smaller amount for payment with different payment modes or accounts.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-qr
  [payNowAmount]="payNowAmount"
  [pacNumber]="pacDetails?.pacNumber"
  [isGenerateQrClicked]="isGenerateQrClicked"
  (payNowQrPopupClosed)="handlePayNowPopupClosed()"
>
</app-qr>

